import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91776164"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-lg modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "add-reporttype-modal-label"
}, " Report Type ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Slug", -1))
const _hoisted_11 = { class: "col-sm-9" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "form-group row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Name", -1))
const _hoisted_15 = { class: "col-sm-9" }
const _hoisted_16 = { class: "form-group row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Display Name", -1))
const _hoisted_18 = { class: "col-sm-9" }
const _hoisted_19 = { class: "form-group row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "New report can be created on app", -1))
const _hoisted_21 = { class: "col-sm-9" }
const _hoisted_22 = {
  key: 0,
  class: "form-group row"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Dictionary", -1))
const _hoisted_24 = { class: "col-sm-9" }
const _hoisted_25 = {
  key: 1,
  class: "form-group row"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Is visible to ACT PIs", -1))
const _hoisted_27 = { class: "col-sm-9" }
const _hoisted_28 = {
  key: 2,
  class: "form-group row"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "List visible customer to ACT PIs", -1))
const _hoisted_30 = { class: "col-sm-9" }
const _hoisted_31 = { class: "modal-footer" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]

import $ from 'jquery';
import { ref, computed, inject } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { DxSwitch } from 'devextreme-vue/switch';

import { Dictionary, DictionaryReportType } from "@/models";

// Define props

export default /*#__PURE__*/_defineComponent({
  __name: 'ReportTypeModal',
  props: {
    id: {},
    operation: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

// Using Vuex store
const store = useStore();
const actProperty: any = inject('actProperty');
const toasted = useToast();

const reportTypeModalAdd = ref(null);

// Computed properties and methods
const dictionary = computed((): Dictionary => store.getters['dictionary/current']);
const activeReportType = computed(() => store.getters['dictionary/activeReportType']);
const companyNameOptions = ref<string[]>([]);

// Actions
const addReportType = async (reporttype: DictionaryReportType): Promise<any> => {
  return store.dispatch('dictionary/addReportType', reporttype);
};

const setDictionaryDeep = async (payload: { path: string; data: any }): Promise<any> => {
  return store.dispatch('dictionary/setDictionaryDeep', payload);
};

const getReportactiveCompanyNameOptions = async (reportname: string): Promise<any> => {
  return store.dispatch('customers/getReportactiveCompanyNameOptions', reportname);
};

const setActiveReportType = (reporttype: DictionaryReportType) => {
  store.commit('dictionary/setActiveReportType', reporttype);
};

const setReportTypeDeep = (payload: { path: string; data: any }) => {
  store.commit('dictionary/setReportTypeDeep', payload);
};

// Computed properties
const slug = computed({
  get: () => activeReportType.value.slug,
  set: (val: string) => setReportTypeDeep({ path: "slug", data: val })
});

const name = computed({
  get: () => activeReportType.value.name,
  set: (val: string) => setReportTypeDeep({ path: "name", data: val })
});

const displayname = computed({
  get: () => activeReportType.value.displayname,
  set: (val: string) => setReportTypeDeep({ path: "displayname", data: val })
});

const createallowedflag = computed({
  get: () => activeReportType.value.createallowed,
  set: (val: boolean) => setReportTypeDeep({ path: "createallowed", data: val })
});

const dictionaryflag = computed({
  get: () => activeReportType.value.dictionaryflag,
  set: (val: boolean) => setReportTypeDeep({ path: "dictionaryflag", data: val })
});

const accessiblebyactpi = computed({
  get: () => activeReportType.value.accessiblebyactpi,
  set: (val: boolean) => setReportTypeDeep({ path: "accessiblebyactpi", data: val })
});

const accessiblebyactpicompanynamelist = computed({
  get: () => activeReportType.value.accessiblebyactpicompanynamelist,
  set: (val: string[]) => setReportTypeDeep({ path: "accessiblebyactpicompanynamelist", data: val })
});


// Helper methods converted to arrow functions
const isCorereport = () => {
  const corereports = ["inventory", "soc", "checkin", "checkout", "property visit"];
  return corereports.includes(activeReportType.value.slug);
};

const isPV = () => slug.value === 'property visit';

const init = () => {
  getReportactiveCompanyNameOptions(activeReportType.value.slug)
  .then((values) => {
    companyNameOptions.value = values;
  })
  .catch((err) => {
    actProperty.displayError(err);
  });
}

const add = async () => {
  addReportType(activeReportType.value)
    .then(() =>
      toasted.success(`Added "${activeReportType.value.name}"`)
    )
    .then(() => reset())
    .catch((err: any) => {
      actProperty.displayError(err);
    });
    hide();
};

const save = async () => {
  if (dictionary.value.reporttypes) {
    let index = dictionary.value.reporttypes?.findIndex(
      (f) => f.slug == activeReportType.value.slug
    );
    if (index >= 0) {
      setDictionaryDeep({
        path: `reporttypes[${index}]`,
        data: activeReportType.value,
      })
        .then(() =>
          toasted.warning(`Locally saved "${activeReportType.value.name}. Please remember to press final Save"`)
        )
        .then(() => reset())
        .catch((err: any) => {
          actProperty.displayError(err);
        });
    }
  }
  hide();

};

const reset = () => {
  setActiveReportType(new DictionaryReportType());
};

const canSave = (): boolean => {
  return !!name.value && !!displayname.value;
}

const show = () => {
  if ($(`#${props.id}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.id + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.id}`).show();
  }
}
const hide = () => {
  if ($(`#${props.id}`).length > 0) {
    $(`#${props.id}` + 'Backdrop').remove();
    $(`#${props.id}`).hide();
  }
};

__expose({init, add, show, hide});

return (_ctx: any,_cache: any) => {
  const _component_multiselect_text = _resolveComponent("multiselect-text")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`add-reporttype-modal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("form", null, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((slug).value = $event)),
                    disabled: _ctx.operation != 'add'
                  }, null, 8, _hoisted_12), [
                    [_vModelText, slug.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((name).value = $event))
                  }, null, 512), [
                    [_vModelText, name.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((displayname).value = $event))
                  }, null, 512), [
                    [_vModelText, displayname.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: createallowedflag.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((createallowedflag).value = $event)),
                    onValueChanged: _cache[5] || (_cache[5] = ($event: any) => (setReportTypeDeep({path: 'createallowed', data: $event.value})))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              (!isCorereport())
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_unref(DxSwitch), {
                        modelValue: dictionaryflag.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dictionaryflag).value = $event)),
                        onValueChanged: _cache[7] || (_cache[7] = ($event: any) => (setReportTypeDeep({path: 'dictionaryflag', data: $event.value})))
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!isCorereport() || isPV())
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_unref(DxSwitch), {
                        modelValue: accessiblebyactpi.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((accessiblebyactpi).value = $event)),
                        onValueChanged: _cache[9] || (_cache[9] = ($event: any) => (setReportTypeDeep({path: 'accessiblebyactpi', data: $event.value})))
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              ((!isCorereport() || isPV()) && accessiblebyactpi.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, [
                      _createVNode(_component_multiselect_text, {
                        modelValue: accessiblebyactpicompanynamelist.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((accessiblebyactpicompanynamelist).value = $event)),
                        options: companyNameOptions.value,
                        multiple: "",
                        "allow-empty": true,
                        taggable: false
                      }, null, 8, ["modelValue", "options"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mr-auto",
            "data-dismiss": "modal",
            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, " Back "),
          (_ctx.operation == 'add')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "submit",
                class: "btn btn-primary",
                onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (add()), ["prevent"])),
                disabled: !canSave()
              }, " Add ", 8, _hoisted_32))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "submit",
                class: "btn btn-primary",
                onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (save()), ["prevent"])),
                disabled: !canSave()
              }, " Ok ", 8, _hoisted_33))
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})